/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassEligibilityTypeEnum,
  ClassEligibilityTypeEnumOptional,
  ClassEligibilityTypeEnumMetaI,
  ClassEligibilityTypeEnumTrackedI,
} from "./class-eligibility-type-enum";
import {
  ClassEligibilityTypeEnumTracked,
  ClassEligibilityTypeEnumMeta,
} from "./class-eligibility-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeOverrideBase,
  UnifiedClassTypeOverrideBaseOptional,
  UnifiedClassTypeOverrideBaseMetaI,
  UnifiedClassTypeOverrideBaseTrackedI,
} from "./unified-class-type-override-base";
import {
  UnifiedClassTypeOverrideBaseTracked,
  UnifiedClassTypeOverrideBaseMeta,
} from "./unified-class-type-override-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeRef,
  UnifiedClassTypeRefOptional,
  UnifiedClassTypeRefMetaI,
  UnifiedClassTypeRefTrackedI,
} from "./unified-class-type-ref";
import {
  UnifiedClassTypeRefTracked,
  UnifiedClassTypeRefMeta,
} from "./unified-class-type-ref";

/**
 *
 * @export
 * @interface ClassTypeOverrideDTO
 */
export interface ClassTypeOverrideDTOOptional extends UnifiedClassTypeOverrideBaseOptional {
  /**
   *
   * @type {PersonRef}
   * @memberof ClassTypeOverrideDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof ClassTypeOverrideDTO
   */
  typeId?: UnifiedClassTypeRefOptional;
  /**
   *
   * @type {number}
   * @memberof ClassTypeOverrideDTO
   */
  season?: number;
  /**
   *
   * @type {ClassEligibilityTypeEnum}
   * @memberof ClassTypeOverrideDTO
   */
  overrideType?: ClassEligibilityTypeEnum;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassTypeOverrideDTO
   */
  programId?: ProgramTypeRefOptional;
}

export interface ClassTypeOverrideDTO
  extends ClassTypeOverrideDTOOptional, UnifiedClassTypeOverrideBase {
  /**
   *
   * @type {PersonRef}
   * @memberof ClassTypeOverrideDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof ClassTypeOverrideDTO
   */
  typeId?: UnifiedClassTypeRef;
  /**
   *
   * @type {number}
   * @memberof ClassTypeOverrideDTO
   */
  season?: number;
  /**
   *
   * @type {ClassEligibilityTypeEnum}
   * @memberof ClassTypeOverrideDTO
   */
  overrideType?: ClassEligibilityTypeEnum;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassTypeOverrideDTO
   */
  programId?: ProgramTypeRef;
}

export interface ClassTypeOverrideDTOTrackedI extends UnifiedClassTypeOverrideBaseOptional {
  /**
   *
   * @type {PersonRef}
   * @memberof ClassTypeOverrideDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof ClassTypeOverrideDTO
   */
  typeId?: UnifiedClassTypeRefTrackedI;
  typeIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeOverrideDTO
   */
  season?: number;
  seasonIsSet: boolean;
  /**
   *
   * @type {ClassEligibilityTypeEnum}
   * @memberof ClassTypeOverrideDTO
   */
  overrideType?: ClassEligibilityTypeEnum;
  overrideTypeIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassTypeOverrideDTO
   */
  programId?: ProgramTypeRefTrackedI;
  programIdIsSet: boolean;
}

transformDatesMap.set(
  "ClassTypeOverrideDTO",
  function (model: ClassTypeOverrideDTO) {
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatestypeId = transformDatesMap.get("UnifiedClassTypeRef");
    if (transformDatestypeId && model.typeId) {
      transformDatestypeId(model.typeId);
    }
    const transformDatesprogramId = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogramId && model.programId) {
      transformDatesprogramId(model.programId);
    }
  },
);

export type ClassTypeOverrideDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  typeId: PropertyMeta<UnifiedClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  season: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  overrideType: PropertyMeta<ClassEligibilityTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  programId: PropertyMeta<ProgramTypeRefMetaI>;
}>;

export var ClassTypeOverrideDTOMeta: ClassTypeOverrideDTOMetaI =
  {} as ClassTypeOverrideDTOMetaI;
ClassTypeOverrideDTOMeta = typeMeta("ClassTypeOverrideDTO", {
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  typeId: propertyMeta("typeId", false, false, false, UnifiedClassTypeRefMeta),
  season: propertyMeta("season", false, false, false, MetaTypesBase.number),
  overrideType: propertyMeta(
    "overrideType",
    false,
    false,
    false,
    ClassEligibilityTypeEnumMeta,
  ),
  programId: propertyMeta("programId", false, false, false, ProgramTypeRefMeta),
});

const metaI = ClassTypeOverrideDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    UnifiedClassTypeOverrideBaseMeta,
  ]);
  metaI.personId.inheritedFrom = UnifiedClassTypeOverrideBaseMeta.personId;
  metaI.typeId.inheritedFrom = UnifiedClassTypeOverrideBaseMeta.typeId;
  metaI.season.inheritedFrom = UnifiedClassTypeOverrideBaseMeta.season;
  metaI.overrideType.inheritedFrom =
    UnifiedClassTypeOverrideBaseMeta.overrideType;
});

export class ClassTypeOverrideDTOTracked
  extends UnifiedClassTypeOverrideBaseTracked
  implements ClassTypeOverrideDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  typeId__I?: UnifiedClassTypeRefTracked = undefined;
  typeIdIsSet: boolean = false;
  set typeId(v: undefined | UnifiedClassTypeRefTracked) {
    if (v !== undefined) {
      this.typeId__I = v;
      this.typeIdIsSet = true;
    } else {
      this.typeId__I = v || undefined;
      this.typeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeId() {
    return this.typeId__I;
  }
  season__I?: number = undefined;
  seasonIsSet: boolean = false;
  set season(v: undefined | number) {
    if (v !== undefined) {
      this.season__I = v;
      this.seasonIsSet = true;
    } else {
      this.season__I = v || undefined;
      this.seasonIsSet = false;
    }
    this.changeTracker = true;
  }
  get season() {
    return this.season__I;
  }
  overrideType__I?: ClassEligibilityTypeEnum = undefined;
  overrideTypeIsSet: boolean = false;
  set overrideType(v: undefined | ClassEligibilityTypeEnum) {
    if (v !== undefined) {
      this.overrideType__I = v;
      this.overrideTypeIsSet = true;
    } else {
      this.overrideType__I = v || undefined;
      this.overrideTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideType() {
    return this.overrideType__I;
  }
  programId__I?: ProgramTypeRefTracked = undefined;
  programIdIsSet: boolean = false;
  set programId(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.programId__I = v;
      this.programIdIsSet = true;
    } else {
      this.programId__I = v || undefined;
      this.programIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get programId() {
    return this.programId__I;
  }
  constructor(config?: ClassTypeOverrideDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personId?.setIds();

    this.typeId?.setIds();

    this.programId?.setIds();
  }
  assignFrom(
    config: ClassTypeOverrideDTOOptional,
    options?: AssignOptions,
  ): ClassTypeOverrideDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (config.typeId && this.typeIdApplyFilter(optionsRequired.filter)) {
      this.typeId = new UnifiedClassTypeRefTracked(config.typeId, options);
      if (optionsRequired.unassign) this.typeIdIsSet = false;
      else this.typeIdIsSet = true;
    }
    if (config.season && this.seasonApplyFilter(optionsRequired.filter)) {
      this.season = config.season;
      if (optionsRequired.unassign) this.seasonIsSet = false;
      else this.seasonIsSet = true;
    }
    if (
      config.overrideType &&
      this.overrideTypeApplyFilter(optionsRequired.filter)
    ) {
      this.overrideType = config.overrideType;
      if (optionsRequired.unassign) this.overrideTypeIsSet = false;
      else this.overrideTypeIsSet = true;
    }
    if (config.programId && this.programIdApplyFilter(optionsRequired.filter)) {
      this.programId = new ProgramTypeRefTracked(config.programId, options);
      if (optionsRequired.unassign) this.programIdIsSet = false;
      else this.programIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassTypeOverrideDTOTrackedI {
    const cloned = {} as ClassTypeOverrideDTOTrackedI;
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.typeIdIsSetDeep() &&
      this.typeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIdIsSet = true;
      cloned.typeId = this.typeId?.removeUnset(filter);
    } else {
      //cloned.typeIdIsSet = false
    }
    if (
      this.seasonIsSetDeep() &&
      this.seasonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.seasonIsSet = true;
      cloned.season = this.season;
    } else {
      //cloned.seasonIsSet = false
    }
    if (
      this.overrideTypeIsSetDeep() &&
      this.overrideTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideTypeIsSet = true;
      cloned.overrideType = this.overrideType;
    } else {
      //cloned.overrideTypeIsSet = false
    }
    if (
      this.programIdIsSetDeep() &&
      this.programIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIdIsSet = true;
      cloned.programId = this.programId?.removeUnset(filter);
    } else {
      //cloned.programIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassTypeOverrideDTOTrackedI {
    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.typeIdApplyFilter(filter)) this.typeIdIsSet = false;
    this.typeId?.unassignAll(filter);

    if (!this.seasonApplyFilter(filter)) this.seasonIsSet = false;

    if (!this.overrideTypeApplyFilter(filter)) this.overrideTypeIsSet = false;

    if (!this.programIdApplyFilter(filter)) this.programIdIsSet = false;
    this.programId?.unassignAll(filter);

    return this;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeOverrideDTOMeta.personId,
      ClassTypeOverrideDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  typeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeOverrideDTOMeta.typeId,
      ClassTypeOverrideDTOMeta,
      this.typeId,
      this,
    );
  }
  typeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIdIsSet && this.typeIdApplyFilter(filter)) return true;
    return this.typeId?.anySet(filter) == true;

    return false;
  }
  seasonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeOverrideDTOMeta.season,
      ClassTypeOverrideDTOMeta,
      this.season,
      this,
    );
  }
  seasonIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.seasonIsSet && this.seasonApplyFilter(filter)) return true;

    return false;
  }
  overrideTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeOverrideDTOMeta.overrideType,
      ClassTypeOverrideDTOMeta,
      this.overrideType,
      this,
    );
  }
  overrideTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.overrideTypeIsSet && this.overrideTypeApplyFilter(filter))
      return true;

    return false;
  }
  programIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeOverrideDTOMeta.programId,
      ClassTypeOverrideDTOMeta,
      this.programId,
      this,
    );
  }
  programIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIdIsSet && this.programIdApplyFilter(filter)) return true;
    return this.programId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.typeIdIsSetDeep(filter)) return true;
    if (this.seasonIsSetDeep(filter)) return true;
    if (this.overrideTypeIsSetDeep(filter)) return true;
    if (this.programIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
